<template>
        <div style="display: inline-block;">
            <strong v-on:click="delay_download()" style="color:hotpink;display: block;cursor: pointer;">{{description}}(descargar AIDCNS-NORMA)</strong>
            <p style='red'>{{error}}</p>
        </div>
</template>
<script>
// import axios from 'axios';
import { storage } from '../../firebase'
import { mapGetters } from "vuex";
export default {
    name: "download-file",
    data () {
      return {
        disabled: false,
        timeout: null,
        error: '',
      }
    },
    // TODO, pass an array
    props: ['description'],
    methods: {
        download() {
            var pathReference = storage.ref('programs/aidc_memoria_v0.1.0.exe');
            pathReference.getDownloadURL().then(function(url) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'programs/aidc_memoria_v0.1.0.exe');
                document.body.appendChild(link);
                link.click();
            }).catch(function(error) {

            switch (error.code) {
                case 'storage/object-not-found':
                    error = 'no encontrado'
                // File doesn't exist
                break;

                case 'storage/unauthorized':
                // User doesn't have permission to access the object
                    error = 'no autorizado'
                break;

                case 'storage/canceled':
                // User canceled the upload
                    error = 'cancelado'
                break;

                case 'storage/unknown':
                // Unknown error occurred, inspect the server response
                    error = 'desconocido'
                break;
            }
            });
        },
        delay_download (projectNumber, sector) {
            this.disabled = true

            this.timeout = setTimeout(() => {
            this.disabled = false
            }, 2000)

            this.download(projectNumber, sector)
        },
        beforeDestroy () {
            // clear the timeout before the component is destroyed
            clearTimeout(this.timeout)
        }
    },
    computed: {
        ...mapGetters({
        user: "user"
        }),
        ...mapGetters({
        token: "token"
        })
    },
}
</script>
<style>
</style>
